import React from 'react';

import { TableStyle } from './style';

export default function TableYear({ children, year }) {
  return (
    <TableStyle>
      <thead>
        <tr>
          <th>Obrigações Acessórias Anuais</th>
          <th className="text">20{year}</th>
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </TableStyle>
  );
}
